import { cn } from '@/lib/core/utils/cn';

interface ProgressDotsProps {
  step: number;
  total?: number;
  light?: boolean;
}

export function ProgressDots({ step, total = 3, light = false }: ProgressDotsProps) {
  return (
    <div className="flex items-center gap-2" aria-hidden="true">
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={cn(
            'block h-px w-4',
            light ? (i < step ? 'bg-white' : 'bg-white/40') : i < step ? 'bg-[#1a1a1a]' : 'bg-[#d1d1d1]'
          )}
        />
      ))}
    </div>
  );
}
